var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',{staticClass:"mb-1",attrs:{"vs-type":"flex","vs-align":"flex-end"}},[_c('vs-col',{attrs:{"vs-w":"10"}},[(_vm.count && _vm.count > 0)?_c('h5',[_vm._v(_vm._s(_vm.title)+" ("+_vm._s(_vm.count)+")")]):_c('h5',[_vm._v(_vm._s(_vm.title))])]),_c('vs-col',{attrs:{"vs-type":"flex","vs-justify":"flex-end","vs-w":"2"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }